import { render, staticRenderFns } from "./sample_list.vue?vue&type=template&id=27740943&scoped=true&"
import script from "./sample_list.vue?vue&type=script&lang=js&"
export * from "./sample_list.vue?vue&type=script&lang=js&"
import style0 from "./sample_list.vue?vue&type=style&index=0&id=27740943&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27740943",
  null
  
)

export default component.exports